import VueI18n from 'vue-i18n'
import messages from '@/lang/ui.js';
import Vue from 'vue'

Vue.use(VueI18n);
export default new VueI18n({
    locale: 'fa',
    messages,
})
